import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppLayout, { PageHeader } from "@/components/app/AppLayout";
import { useAuth } from "@/context/AuthContext";
import { marketApi } from "@/lib/marketApi";
import MarketChatPanel from "@/components/marketplace/MarketChatPanel";

export default function MarketChat() {
  const { tid } = useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);

  const refresh = async () => {
    if (!auth?.token) return;
    const list = await marketApi.threads(auth.token);
    setThreads(list);
    if (tid) {
      const t = list.find((x) => x.id === tid);
      if (t) setActive(t);
    } else if (!active && list.length) {
      setActive(list[0]);
    }
  };

  useEffect(() => { refresh(); }, [auth?.token, tid]); // eslint-disable-line

  if (!auth?.user) {
    return <AppLayout hideRightRail><p className="text-center text-sm text-ink-mid py-12">Inicia sesión para ver tus mensajes</p></AppLayout>;
  }

  return (
    <AppLayout hideRightRail>
      <PageHeader
        kicker="◊ Mensajes Marketplace"
        title="Conversaciones."
        subtitle="Habla directo con compradores y vendedores."
      />

      <div className="grid md:grid-cols-12 gap-4">
        {/* Threads list */}
        <aside className={`md:col-span-4 lg:col-span-3 border hairline bg-cream-card rounded-2xl overflow-hidden ${active ? "hidden md:block" : ""}`}>
          <div className="max-h-[70vh] overflow-auto" data-testid="threads-list">
            {threads.length === 0 && (
              <p className="p-6 text-center text-xs text-ink-mid">Aún no tienes conversaciones.</p>
            )}
            {threads.map((t) => (
              <button key={t.id}
                      onClick={() => { setActive(t); navigate(`/marketplace/chat/${t.id}`); }}
                      data-testid={`thread-${t.id}`}
                      className={`w-full text-left p-3 border-b hairline last:border-b-0 hover:bg-cream transition flex items-center gap-3
                        ${active?.id === t.id ? "bg-cream" : ""}`}>
                {t.listing_photo
                  ? <img src={t.listing_photo} alt="" className="w-10 h-10 rounded-lg object-cover shrink-0" />
                  : <div className="w-10 h-10 rounded-lg bg-cream-deep shrink-0" />}
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate">{t.counterparty_name}</p>
                  <p className="text-[11px] text-ink-mid truncate">{t.last_message}</p>
                  <p className="text-[10px] font-mono text-ink-mid mt-0.5">{t.listing_title}</p>
                </div>
                {t.unread > 0 && (
                  <span className="bg-coral text-white text-[10px] font-mono rounded-full w-5 h-5 flex items-center justify-center shrink-0">
                    {t.unread}
                  </span>
                )}
              </button>
            ))}
          </div>
        </aside>

        <section className={`md:col-span-8 lg:col-span-9 ${!active ? "hidden md:flex md:items-center md:justify-center md:min-h-[40vh]" : ""}`}>
          {active ? (
            <div className="w-full">
              <MarketChatPanel thread={active} onBack={() => setActive(null)} onThreadUpdate={refresh} />
            </div>
          ) : (
            <p className="text-sm text-ink-mid">Selecciona una conversación.</p>
          )}
        </section>
      </div>
    </AppLayout>
  );
}
